import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrevious = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "Previous track"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M5 6h3.5v20H5zM27 6v20l-17.5-10z" })]
});
const ForwardRef = forwardRef(SvgPrevious);
export default ForwardRef;
